export const API_NODE_BASE = process.env.REACT_APP_API_NODE_BASE_URL;
// Public MCP server base (mcp.koob.tech); falls back to the API host locally.
export const MCP_BASE = process.env.REACT_APP_MCP_BASE_URL || API_NODE_BASE;
// Public API documentation site (docs.koob.tech / docs.v2koob.tech).
export const DOCS_BASE =
  process.env.REACT_APP_DOCS_BASE_URL || 'https://docs.koob.tech';
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
// KOOB cloud map style (KD-3753); unset falls back to Google's DEMO_MAP_ID.
export const GOOGLE_MAPS_MAP_ID = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID;
export const KOOB_TO_URL = process.env.REACT_APP_TO_BASE_URL;
export const APP_NAME = 'KOOB';
export const EASIA_TRAVEL_ORG_IDS = '10,11,12,13';

export const KOEDIA = 'KOEDIA';
export const RAKUTEN = 'RAKUTEN';
export const DMC = 'DMC';
export const KOOB = 'KOOB';
export const STAAH = 'STAAH';
export const TL_LINCOLN = 'TL_LINCOLN';

export const PASSWORD_REGEX = /^[A-Za-z0-9%!?,.(){}\-_@*^$&#]+$/;

export const DEFAULT_LOCAL = 'en';
export const PER_PAGE_FOR_LIST = 12;
export const PER_PAGE = 50;
export const PER_PAGE_FOR_CATALOG = 12;
